// CORE
import React, { useState } from 'react';

// MUI
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

// DATA

import { DialogActions } from '@mui/material';
import QButton from 'components/QButton';
import QIllustration from 'components/QIllustration';
// LOCAL

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
  },
  confirmationRoot: {
    paddingTop: theme.spacing(8),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  inputFields: {
    margin: `${theme.spacing(2)} 0`,
  },
  dialogActions: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },
}));

const SendInstitutionRequest = ({
  onSendInstitutionRequest,
  handleReset,
}: {
  handleReset: () => Promise<void>;
  onSendInstitutionRequest: ({ institutionName, loginURL }: { institutionName: string; loginURL: string }) => void;
}) => {
  const { classes } = useStyles();

  const [institutionName, setInstitutionName] = useState('');
  const [loginURL, setLoginURL] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleSubmit = () => {
    onSendInstitutionRequest({ institutionName, loginURL });
    setShowConfirmation(true);
  };

  if (showConfirmation) {
    return (
      <Box className={classes.confirmationRoot}>
        <Box padding={3}>
          <QIllustration name='thumbsUp' size='lg' />
        </Box>
        <Box marginTop={1} marginBottom={4}>
          <Typography variant='bodyRegular'>Your request has been submitted.</Typography>
        </Box>
        <QButton variant={'contained'} onClick={handleReset}>
          got it
        </QButton>
      </Box>
    );
  }

  return (
    <>
      <Box className={classes.root}>
        <Box display={'flex'} alignItems={'center'}>
          <Box padding={3}>
            <QIllustration name='planeFly' size='lg' />
          </Box>
          <Box display={'flex'} flexDirection={'column'} marginTop={2} marginLeft={2}>
            <Typography variant='bodyRegular'>Enter the details below to send a request to Simplifi.</Typography>
            <TextField
              value={institutionName}
              onChange={(e) => setInstitutionName(e.target.value)}
              variant={'filled'}
              label={'Financial institution'}
              className={classes.inputFields}
            />
            <TextField
              value={loginURL}
              onChange={(e) => setLoginURL(e.target.value)}
              variant={'filled'}
              label={'Login URL'}
              className={classes.inputFields}
            />
          </Box>
        </Box>
      </Box>
      <DialogActions className={classes.dialogActions}>
        <QButton
          onClick={handleSubmit}
          variant={'contained'}
          disabled={institutionName.length === 0 || loginURL.length === 0}
        >
          request
        </QButton>
      </DialogActions>
    </>
  );
};

export default SendInstitutionRequest;
